/**
 * Derives the summary counts shown in the toolbar stats pills: number of timed activities, their total
 * hours, and how many of the trip's nights are covered by accommodation.
 */
import { useMemo } from 'react';

import type { BoardModel } from './model';

export interface CostSchemeStats {
  activities: number;
  totalHours: number;
  coveredNights: number;
  totalNights: number;
}

export function useCostSchemeStats(model: BoardModel): CostSchemeStats {
  return useMemo(() => {
    const timed = model.parts.filter((p) => p.kind === 'timed');
    const coveredNights = model.parts
      .filter((p) => p.kind === 'accommodation')
      .reduce((sum, p) => sum + p.span, 0);
    return {
      activities: timed.length,
      totalHours: timed.reduce((sum, p) => sum + p.hours, 0),
      coveredNights,
      totalNights: Math.max(0, model.lengthDays - 1),
    };
  }, [model]);
}
